import { css, SerializedStyles } from '@emotion/react';

export const checkboxStyles = (): SerializedStyles =>
    css({
        '.field': {
            display: 'flex',
        },
    });
